(function () {
    'use strict';

    angular.module("imApp").factory("pohCompAddScanService", ['$ihttp', function ($ihttp) {
        let service = {
            scanBarcode: function (setting) {
                return $ihttp.post({
                    method: 157,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
